import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'qira-theme';
const DARK_CLASS = 'dark-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly isDark = signal<boolean>(this.readInitial());

  constructor() {
    this.apply(this.isDark());
  }

  toggle(): void {
    const next = !this.isDark();
    this.isDark.set(next);
    this.apply(next);
    try { localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light'); } catch {}
  }

  private apply(dark: boolean): void {
    const body = document.body;
    if (dark) body.classList.add(DARK_CLASS);
    else body.classList.remove(DARK_CLASS);
  }

  private readInitial(): boolean {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'dark') return true;
      if (stored === 'light') return false;
    } catch {}
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  }
}
